<template name="selectSecurityPost">
    <div class="select-security-post-container" v-show="isSelectPopShown">
      <div class="select-security-pop">
        <div class="select-security-title">
          <h3>选择门岗</h3>
          <i v-if="currentPostId !== 0" class="iconfont icon-close" @click="closeSelectPop"></i>
        </div>
        <radioSelect
          :dataList="postList"
          :propName="propName"
          :idScopeName="idScopeName"
          @radioSelect="handleRadioSelect"
        >
        </radioSelect>
        <div class="button" @click="confirmSelectPost">确定</div>
      </div>
      <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    </div>
</template>

<script type="text/javascript">
import { getSecurityGuardPostList, setPosition } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import radioSelect from '@/components/radioSelect.vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import myAuth from '@/utils/auth';

export default {
  name: 'selectSecurityPost',
  components: {
    radioSelect,
    Loading,
  },
  data() {
    return {
      postList: [
      ],
      propName: 'postName',
      idScopeName: 'post',
      postId: 0,
      isLoading: false,
    };
  },
  props: {
    isSelectPopShown: Boolean,
    isFirstSet: Boolean,
    currentPostId: Number,
  },
  created() {
    getSecurityGuardPostList().then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        const { model } = res.data.content;
        model.forEach((x, idx) => {
          x.checked = this.$props.currentPostId ? x.id === this.$props.currentPostId : idx === 0;
        });
        this.postId = this.$props.currentPostId || model[0].id;
        this.postList = model;
        this.$emit('getPostList', this.postList.find(x => x.id === this.currentPostId));
      }
    });
  },
  methods: {
    confirmSelectPost() {
      this.isLoading = true;
      setPosition(this.postId).then((res) => {
        this.isLoading = false;
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          const { postName } = this.postList.find(x => x.id === this.postId);
          const that = this;
          myAuth.getRefreshAccessToken().then((model) => {
            myAuth.setLocalAccessToken(model);
            that.$emit('setPost', { id: that.postId, postName, status: res.data.content.model });
          }); 
        }
      });
    },
    handleRadioSelect(postId) {
      this.postId = postId;
    },
    closeSelectPop() {
      this.$emit('closeSelectPop');
    },
  },
};
</script>
<style scoped lang="scss">
  .select-security-post-container {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(34, 34, 34, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    .select-security-pop {
      padding: 20px 30px;
      background: #fff;
      border-radius: 4px;
      width: 43.8%;
      .select-security-title {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 10px;
        h3 {
          font-size: 18px;
          color: #4a4a4a;
          font-weight: bold;
        }
        i {
          font-size: 20px;
        }
      }
      .button {
        width: 70.8%;
        line-height: 46px;
        border-radius: 5px;
        background-image: linear-gradient(81deg, #f36443, #e42029);
        color: #fff;
        text-align: center;
        font-size: 15px;
        margin: auto;
      }
    }
  }
</style>
